// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__xatBE","productName":"Table_productName__1hpt-"};